module.exports = __webpack_public_path__ + "img/banner-1.30f6b834.jpg";